import { render } from "./CommentBubble.vue?vue&type=template&id=42ded722"
import script from "./CommentBubble.vue?vue&type=script&lang=js"
export * from "./CommentBubble.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__